<template>
	<div class="wrapper">
		<div class="header"><BaseHeader :title="'商家产品列表'" /></div>
		<div class="content">
			<div class="my-location">
			    <span>当前位置</span>
			    <span>{{myLocation.address}}</span>
			    <div style="float: right">
			        <van-button type="primary" style="background-color: #00BFFF;border-color: #00BFFF" size="mini" @click="hadleGetLocation">刷新位置</van-button>
			    </div>
			</div>
			<div class="recommend-box goods-box">
				<div class="goods-list">
					<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" style="width: 100%;">
						<div class="goods-item" v-for="item in goodsList" :key="item.id" @click="goDetail(item.id)">
                            <div class="goods-img">
                                <img v-lazy="item.logo" alt="" />
                            </div>
                            <div class="goods-info">
                                <div class="goods-name">
                                    <span>{{item.name}}</span>
                                </div>
                                <div class="goods-title">{{item.service_tag}}</div>
                                <div class="goods-postage">
                                    <span style="border: 1px solid #9C6838;padding: 2px;border-radius: 5px;color: #9C6838">距离您{{item.dis_show}}</span>
                                </div>
                                <div class="goods-price">
                                    <p class="new-price" style="color: #C6241A;">
                                        ￥{{item.price}}
                                    </p>
                                    <p class="old-price" v-if="item.high_price > 0"><s>￥{{item.high_price}}</s></p>
                                </div>
                            </div>
                        </div>
					</van-list>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseHeader from '../../components/BaseHeader';
import { getCateShopGoods } from '../../service/goodsService';
import { Toast } from 'vant';
import {wecharShare} from "../../util/weChat.js";

export default {
	name: 'GoodsMuster',
	data() {
		return {
			goodsList: [],
			loading: false,
			finished: false,
			offset: {
				page: 0,
				limit: 10
			},
			cateid: null,
			searchKey: '', //搜索关键字
			active: 0, //搜索类别，0综合排序，1销量，2价格
			active1: 0,
			active2: 0,
			active3: 0,
			order: 0,
			myLocation:{
			    address:"",
			    latitude:0,
			    longitude:0,
			},
			shopId:null
		};
	},
	mounted() {
		this.getMyLocation();
		this.cateid = this.$route.params.cateid;
		//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
	},
	methods: {
		getData() {
			if(this.myLocation.latitude == 0){
				return false;
			}
			this.offset.page++;
			getCateShopGoods(this.cateid,this.myLocation.latitude,this.myLocation.longitude,this.offset.page)
				.then(res => {
					if (res.status === 1) {
						this.loading = false;
						if (res.datas.length === 0) {
							this.finished = true;
							this.offset.page = 0;
							return;
						}
						this.goodsList = [...this.goodsList, ...res.datas];
						this.shopId = res.datas[0].shop_id;
					} else {
						Toast(res.msg);
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		getMyLocation() {
			var geolocation = new qq.maps.Geolocation();
			var options = {timeout: 9000};
			geolocation.getLocation(this.showPosition, this.showErr,options);//或者用getLocation精确度比较高
		},
		showPosition(position) {
			console.log(position);
			this.index = 1;
			this.myLocation.latitude = position.lat;
			this.myLocation.longitude = position.lng;
			var str = position.addr;
			str = str.slice(0,15)+'...';
			this.myLocation.address = str;
			this.getData();
			this.show = true;
			this.showLoading = false;
			// this.setMap();
		},
		showErr() {
			console.log("定位失败");
			this.getMyLocation();//定位失败再请求定位，测试使用
		},
		hadleGetLocation(){
			// this.$router.go(0);
			window.location.reload()
		},
		goDetail(id) {
			this.$router.push({
				name: 'shopexchangedetail',
				params: {
					shopId: this.shopId,
					id: id
				}
			});
		},
	},
	components: {
		BaseHeader
	}
};
</script>

<style scoped lang="scss">
	.content{
		background-color: #F6F4F4;
		width: 100%;
	}
	.goods-box{
		display: flex;
		flex-direction: column;
	}
	.goods-list{
		display: flex;
		padding: 5px;
	}
	.goods-item{
		display: flex;
		margin: 5px;
		background-color: #fff;
		border-radius: 10px;
	}
	
	.goods-img img{
		width: 100px;
		height: 100px;
		border-radius: 10px;
	}
	
	.goods-info{
		padding: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	.my-location{
	    background: #ffffff;
	    padding: 10px;
	    box-sizing: border-box;
	    span:nth-child(2){
	        margin-left: 10px;
	        color: #999999;
	    }
	}
</style>
